var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{},on:{"click":function($event){return _vm.$emit('handleClick')}}},[_c(_vm.iconComponent,{tag:"component"}),_c('span',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }